
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/crafts",
      function () {
        return require("private-next-pages/crafts/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/crafts"])
      });
    }
  